<template>
    <div class="info">
        <div>
            <p class="" align="center">
                <b><span><font>浙江省危重患者院际转运</font></span></b><b><span><font>评价表</font></span></b><b><span></span></b>
            </p>
            <table
                    width="100%"
                    class="Table mt10"
                    border="1"
                    cellspacing="0"
                    style="border-collapse: collapse"
            >
                <tr>
                    <td width="187" valign="center">
                        <p class="" align="center">
                            <b><span>转运过程顺利</span></b>
                        </p>
                    </td>
                    <td width="380" valign="top" class="pl20">
                        <input type="radio" readonly disabled :checked="info.transportSmoothStatus">是
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <input type="radio" readonly disabled :checked="!info.transportSmoothStatus">否
                    </td>
                </tr>
                <tr>
                    <td width="187" valign="center">
                        <p class="" align="center">
                            <b><span>转运不良事件</span></b>
                        </p>
                    </td>
                    <td width="380" valign="top" class="pl20">
                        <input type="radio" readonly disabled :checked="info.hasAdverseEvent">有
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <input type="radio" readonly disabled :checked="!info.hasAdverseEvent">无
                    </td>
                </tr>
                <tr>
                    <td width="187" valign="center">
                        <p class="" align="center">
                            <b><span>不良事件类型</span></b
                            ><b><span></span></b>
                        </p>
                    </td>
                    <td width="380" valign="top" class="pl20">
                        <p class="">
                            <input type="radio" :checked="info.ambulanceProblemsStatus" readonly disabled>救护车问题
                            <u>
                                <span class="fs14" :class="{color_red:info.ambulanceProblemsStatus}" v-if="info.ambulanceProblemsStatus">&nbsp;&nbsp;&nbsp;&nbsp;{{info.ambulanceProblemsDesc}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></u>

                        </p>
                        <p class="">
                            <input type="radio" :checked="info.instrumentationProblemsStatus" readonly disabled>仪器设备问题
                            <u>
                                <span class="fs14" :class="{color_red:info.instrumentationProblemsStatus}" v-if="info.instrumentationProblemsStatus">&nbsp;&nbsp;&nbsp;&nbsp;{{info.instrumentationProblemsDesc}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></u>
                        </p>
                        <p class="">
                            <input type="radio" :checked="info.pipelineProblemsStatus" readonly disabled>患者管道问题
                            <u>
                                <span class="fs14" :class="{color_red:info.pipelineProblemsStatus}" v-if="info.pipelineProblemsStatus">&nbsp;&nbsp;&nbsp;&nbsp;{{info.pipelineProblemsDesc}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></u>
                        </p>
                        <p class="">
                            <input :checked="info.illnessChangeStatus" readonly disabled type="radio">患者病情变化
                            <u>
                                <span class="fs14" v-if="info.illnessChangeStatus" :class="{color_red:info.illnessChangeStatus}">&nbsp;&nbsp;&nbsp;&nbsp;{{info.illnessChangeDesc}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></u>
                        </p>
                        <p class="">
                            <input :checked="info.medicalStaffProblemsStatus" readonly disabled type="radio">医护人员问题
                            <u>
                                <span class="fs14" v-if="info.medicalStaffProblemsStatus" :class="{color_red:info.medicalStaffProblemsStatus}">&nbsp;&nbsp;&nbsp;&nbsp;{{info.medicalStaffProblemsDesc}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></u>
                        </p>
                        <p class="">
                            <input :checked="info.othersProblemsStatus" readonly disabled type="radio">其他不良事件
                            <u>
                                <span class="fs14" v-if="info.othersProblemsStatus" :class="{color_red:info.othersProblemsStatus}">&nbsp;&nbsp;&nbsp;&nbsp;{{info.othersProblemsDesc}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></u>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="187" valign="center">
                        <p class="" align="center">
                            <b><span>不良事件处理方式</span></b>
                        </p>
                    </td>
                    <td width="380" valign="top" class="pl20">
                        <p class="">
                            {{info.adverseEventHandleProcess}}
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="187" valign="center">
                        <p class="" align="center">
                            <b><span>不良事件后果</span></b>
                        </p>
                    </td>
                    <td width="380" valign="top" class="pl20">
                        <p class="">
                            {{info.adverseEventResult}}
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="187" valign="center">
                        <p class="" align="center">
                            <b><span>其他建议</span></b>
                        </p>
                    </td>
                    <td width="380" valign="top" class="pl20">
                        <p class="">
                            {{info.othersAdvice}}
                        </p>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "pj-info",
        props: {
            info: {
                type: Object,
                default: () => Object.create(null)
            },
        },
    }
</script>

<style scoped>

</style>